var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('q-tabs',{staticClass:"in-page-navigation",attrs:{"value":_vm.value,"vertical":_vm.$q.screen.gt.sm,"dense":"","outside-arrows":"","indicator-color":"accent","active-bg-color":"white","no-caps":"","inline-label":""},on:{"input":value => _vm.$emit('input', value)}},[_vm._t("default")],2),_vm._t("append")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }